import { useRegion } from 'common/hooks/region';
import moment from 'moment';
import * as React from 'react';
import { SmartRow } from '../../types';

interface Props {
  row: SmartRow;
}

export const Time: React.FC<Props> = (props) => {
  const { row } = props;
  const region = useRegion();

  switch (row.type) {
    case 'placeholder':
      return null;
    case 'no-data':
      return <span>No data available</span>;
    case 'alert':
      return <span>-</span>;
    default:
      break;
  }

  const { screenshotTimestamp } = row;
  const m = moment.tz(screenshotTimestamp, region.timeZone);
  return <span>{m.format('HH:mm z')}</span>;
};
Time.displayName = 'SmartPerDiem.Table.Cell.Time';
